import axios from "../../../../axios";
import Cookies from "js-cookie";

export const GetConsultantDashBoardData = async () => {
  const token = Cookies.get("ConsultantToken");

  return axios.post("/api/Consultant/GetDashboardData", {
    token,
  });
};